import { render, staticRenderFns } from "./fdInventory53.vue?vue&type=template&id=c884b97c"
import script from "./fdInventory53.vue?vue&type=script&lang=js"
export * from "./fdInventory53.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports